import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { BaseFormList, MessageService } from '../../../../core';

import { NgForm } from '@angular/forms';
import { Representante, TypeaheadRepresentanteComponent } from '../../../pessoa/representante';
import { CampanhaRepresentante } from './campanha-representante';
import { CampanhaRepresentantePopulaModalComponent } from './popula-modal';


@Component({
    selector: 'sgt-campanha-representante',
    templateUrl: './campanha-representante.component.html',
    styleUrls: ['./campanha-representante.component.less']
})
export class CampanhaRepresentanteComponent implements BaseFormList<CampanhaRepresentante>, OnInit {
    @Input() entities: CampanhaRepresentante[];
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChildren('typeaheadRepresentante') typeaheadsRepresentantes: QueryList<TypeaheadRepresentanteComponent>;
    @ViewChild('campanhaRepresentantePopulaModal') campanhaRepresentantePopulaModal: CampanhaRepresentantePopulaModalComponent;

    constructor(private messageService: MessageService) { }

    ngOnInit() {
    }

    /** Ao alterar o representante no typeahead */
    onChangeRepresentante(entity: CampanhaRepresentante, representante: Representante) {
        if (representante) {
            entity.idRepresentante = representante.id;
        } else {
            entity.idRepresentante = null;
        }
    }

    insert() {
        if (!this.entities) {
            this.entities = [];
        }

        const entity = new CampanhaRepresentante();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInsertRepresentante(), 200);
    }

    /** Seta o foco no typeahead do representante ao inserir um novo representante */
    private setFocusInsertRepresentante() {
        if (!this.typeaheadsRepresentantes) {
            return;
        }
        // Obtendo o último typeahead para setar o foco
        const typeaheadRepresentante = this.typeaheadsRepresentantes.last;
        if (typeaheadRepresentante) {
            typeaheadRepresentante.setFocus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse representante?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os representantes da campanha estão válidos */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            if (!entity.idRepresentante) {
                this.messageService.info('É necessário informar o representante ou excluir esse representante', 'Informação');
                return false;
            }


            const count = this.entities.filter(entityFilter => entityFilter.idRepresentante && entityFilter.idRepresentante === entity.idRepresentante).length;
            if (count > 1) {
                this.messageService.info(`O representante ${entity.representante.pessoa.nome} já está adicionado. Remova ou altere o representante duplicado`, 'Não é possível adicionar dois representantes iguais');
                return false;
            }
        }

        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos dos representantes desta campanha', 'Atenção');
            return false;
        }

        return true;
    }

    /** Resolve os representantes presentes na campanha */
    resolve() { }

    /** Abre o modal para adicionar os representantes na campanha */
    openPopulaCidadeModal() {
        this.campanhaRepresentantePopulaModal.open();
    }
}
